<template lang="pug">
.control
	vue-ctk-date-time-picker(
		v-model="day"
		:id="id"
		:locale="locale"
		:format="format"
		:label="''"
		:formatted="format"
		:color="'#ff7f2a'"
		:auto-close="true"
		:only-date="true"
		:no-label="true"
		:no-header="true"
		:no-shortcuts="true"
		:no-button="true"
		:no-button-now="true"
		:first-day-of-week="1"
		:min-date="min"
		:max-date="max"
		:range="false"
	)
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import moment from 'moment'

export default {
	components: {
		VueCtkDateTimePicker
	},
	data() {
		return {
			format: 'YYYY-MM-DD',
			locale: null,
			max   : moment().format('YYYY-MM-DD'),
			day   : null
		}
	},
	props: {
		value: {
			type: String,
			required: false
		},
		id: {
			type: String,
			required: false
		},
		min: {
			type: String,
			required: false
		}
	},
    mounted() {
		this.locale = 'it'
	},
	watch: {
		day(val, oldVal) {
			if (val) {
				this.$emit('input', this.day)
			}
		}
	}
}
</script>
